import { ICommonSettings, IWorkflowEngineBaseUrlSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigWorkflowEngineBaseUrlSettings } from "./app-settings-config-workflow-engine-base-url";

export interface IConfigWorkflowEngineBaseUrlInputState {
  showModal: boolean;
  editingWFEngineBaseUrlId: string;
}

export interface IConfigWorkflowEngineBaseUrlInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
  /** Drop the "Default" (platform/preview) option — used where a real setting MUST be picked (WFE download). */
  hideDefaultOption?: boolean;
  /** When set, the field becomes required and shows this message inline if left empty. */
  requiredMessage?: string;
}

export class ConfigWorkflowEngineBaseUrlInput extends PureComponent<
  IConfigWorkflowEngineBaseUrlInputProps,
  IConfigWorkflowEngineBaseUrlInputState
> {
  formInputName = ["apiConfig", "workflowEngineBaseUrlSettingsId"];

  constructor(props: IConfigWorkflowEngineBaseUrlInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingWFEngineBaseUrlId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingWFEngineBaseUrlId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingWFEngineBaseUrlId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      ...(this.props.hideDefaultOption
        ? []
        : [{ id: null, name: "Default" } as unknown as IWorkflowEngineBaseUrlSettings]),
      ...(commonSettings.workflowEngineBaseUrlSettings || [])
    ];

    return (
      <>
        <ConfigWorkflowEngineBaseUrlSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingWFEngineBaseUrlId={this.state.editingWFEngineBaseUrlId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Engine Base URL"
          formInputName={this.formInputName}
          options={options}
          rules={this.props.requiredMessage ? [{ required: true, message: this.props.requiredMessage }] : undefined}
          tooltipContentKey="appsettings_workflow_enginebaseurl"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsWorkflowEngineBaseUrlDropdown"
          addNewTestId="appSettingsWorkflowEngineBaseUrlAddNewButton"
          editTestId="appSettingsWorkflowEngineBaseUrlEditButton"
        />
      </>
    );
  }
}
